var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.series.length)?_c('apexchart',{staticClass:"chart-wrapper",attrs:{"width":"100%","height":"100%","type":"bar","options":_vm.fullOptions.apex,"series":_vm.series}}):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }